import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { Grid } from '@mui/material';
import { LoadBoardTypesList } from 'features/clients/clientConfigs/transports/LoadBoardTypesEnum';
import { useGetClientsWithConfigsQuery } from "features/clients/clientConfigSlice";
import { useEffect, useState } from 'react';
import ConfirmationPopup from '../../../../components/ConfirmationPopup';
import NotificationProvider from '../../../../components/NotificationProvider';
import { useGetLotsQuery } from '../../../lots/lotSlice';
import { usePostLoadMutation } from '../../loadsSlice';
import { bulkPostGroupsStyle } from './BulkPostGroupsStyle';

function BulkPostGroups({ groups, btnStyle = 'contained' }) {

    const classes = bulkPostGroupsStyle();
    let [postLoad, { isLoading: isLoadingDispatchLoad, isError, isSuccess }] = usePostLoadMutation();
    let { data: lots, error: lotError, isLoading: isLoadingLots } = useGetLotsQuery();
    let { data: clientsWithConfigs, error: clientsWithConfigsError, isLoading: isLoadingClientsWithConfigs, isFetching: isFetchingClientsWithConfigs } = useGetClientsWithConfigsQuery();
    const [open, setOpen] = useState(false);
    const [openPopup, setOpenPopup] = useState(false);
    const [createState, setCreateState] = useState('1');
    clientsWithConfigs = clientsWithConfigs || [];

    const loads = createState == '1' ? groups?.flatMap(g => g.loads?.filter(l => !l.loadBoardId && !l.isComplete)) :
        groups?.flatMap(g => g.loads?.filter(l => !l.loadBoardId && l.readyForPosting && !l.isComplete));

    const [mappedLoads, setMappedLoads] = useState(loads || []);

    useEffect(() => {
        if (!isLoadingClientsWithConfigs && loads) {
            setMappedLoads(
                loads.map(l => {
                    var clientConfigs = clientsWithConfigs?.find(c => c.id == l?.clientId);
                    var loadBoardId = clientConfigs?.config?.transportConfig?.loadBoard;
                    return {
                        ...l,
                        loadBoardDesc: LoadBoardTypesList?.find(t => t.id == loadBoardId)?.name
                    };
                })
            );
        }
    }, [isLoadingClientsWithConfigs, loads, clientsWithConfigs]);

    const openDialog = async () => {
        setOpen(true);
    }
    const closeDialog = async () => {
        setOpen(false);
    }

    const dispatch = async () => {
        setOpenPopup(true)
    }

    const onConfirm = async () => {
        let result = await postLoad([{
            loadIds: loads?.map(l => l.id),
            groupIds: loads?.map(l => l.groupId),
        }]);
        if (result?.error) {
            NotificationProvider.error(`Operation failed. ${result?.error?.data?.messages.join(" ")}`)
        } else {
            if (result?.data?.success) {
                NotificationProvider.success(`Successfully posted to load board`);
            } else {
                NotificationProvider.error(`${result?.data?.messages?.join('; ')} `);
            }
        }
        setOpenPopup(false);
        setOpen(false);
    }

    return (
        <div>
            <Button
                variant={btnStyle}
                color="primary"
                onClick={openDialog}
            >
                Post loads to load board
            </Button>
            <Dialog
                open={open}
                onClose={closeDialog}
                aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Post loads to load board</DialogTitle>
                <DialogContent>
                    <Grid item>
                        <div>
                            <FormControl>
                                <RadioGroup
                                    row
                                    name="post-load-radio-group"
                                    value={createState}
                                    onChange={(e) => {
                                        setCreateState(e.target.value)
                                    }}
                                >
                                    <FormControlLabel value="1" control={<Radio />} label="Post All" />
                                    <FormControlLabel value="2" control={<Radio />} label="Post Next Loads" />
                                </RadioGroup>
                            </FormControl>
                        </div>
                        <div>
                            {!!mappedLoads?.length ?
                                <div>
                                    {mappedLoads?.map(load =>
                                        <div>
                                            <b>{`${lots?.find(l => l.id == load?.pickupLocationId)?.name} -> ${lots?.find(l => l.id == load?.deliveryLocationId)?.name} `}</b>
                                            {load?.loadBoardDesc?.length && <div>{`Load board: ${load?.loadBoardDesc}`}</div>}
                                        </div>
                                    )}
                                </div>
                                : <div>There are no load legs ready for posting in the selected groups</div>}
                        </div>

                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={closeDialog}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={dispatch}
                        disabled={!loads?.length}
                    >
                        Submit
                    </Button>
                </DialogActions>
                <ConfirmationPopup
                    onCancel={() => setOpenPopup(false)}
                    onConfirm={onConfirm}
                    open={openPopup}
                    loading={isLoadingDispatchLoad}
                >
                    <div>{`Are you sure you want to submit the load`}</div>
                </ConfirmationPopup>
            </Dialog>
        </div>
    );
}

export default BulkPostGroups;
